import { render } from "./VideoPlayer.vue?vue&type=template&id=9c45547c"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=9c45547c&lang=css"

import exportComponent from "/Users/jyrseige/work/replayAndVote/replayandvote/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__